import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, User, Users2, Lock, Bell, Gamepad2, Users, UserCheck, Banknote, ChevronRight } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import BottomSheet from './BottomSheet';

const LINKS = [
  { id: 'personal', label: 'Personal Info', icon: User, path: '/profile/edit' },
  { id: 'managed-players', label: 'Managed Players', icon: Users2, path: '/profile?tab=managed-players' },
  { id: 'password', label: 'Change Password', icon: Lock, path: '/profile/edit?tab=password' },
  { id: 'notifications', label: 'Notifications', icon: Bell, path: '/profile/edit?tab=notifications' },
  // Same Banknote icon and destination as the profile's own Payouts tab, which
  // is otherwise only reachable by scrolling the tab strip on a phone.
  { id: 'payouts', label: 'Payouts', icon: Banknote, path: '/profile?tab=payouts' },
  { id: 'my-games', label: 'My Games', icon: Gamepad2, path: '/my-games' },
  { id: 'my-teams', label: 'My Teams', icon: Users, path: '/profile/teams' },
  { id: 'my-teammates', label: 'My Teammates', icon: UserCheck, path: '/teammates' },
];

/** Mobile bottom-sheet quick-nav for Me — direct links into the most-visited account
 *  destinations instead of dropping the user on the profile overview every time. */
const MeQuickPanel = ({ isOpen, onClose }) => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const goTo = (path) => {
    onClose();
    navigate(path);
  };

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <div className="flex items-center justify-between px-4 pt-3 pb-2">
        <div className="flex items-center gap-2">
          <User className={`w-5 h-5 ${theme.primary}`} />
          <span className={`font-semibold ${theme.text}`}>Quick Links</span>
        </div>
        <button onClick={onClose} className={`p-1.5 rounded-lg ${theme.cardHover}`}>
          <X className={`w-4 h-4 ${theme.textMuted}`} />
        </button>
      </div>

      <div className={`h-px ${theme.border} bg-current opacity-10 mx-4`} />

      <div className="px-4 py-3 space-y-1">
        {LINKS.map(link => {
          const Icon = link.icon;
          return (
            <button
              key={link.id}
              onClick={() => goTo(link.path)}
              className={`flex items-center justify-between w-full py-2.5 px-3 rounded-lg ${theme.cardHover} text-sm font-medium ${theme.text}`}
            >
              <span className="flex items-center gap-3">
                <Icon className={`w-4 h-4 ${theme.textSecondary}`} />
                {link.label}
              </span>
              <ChevronRight className={`w-4 h-4 ${theme.textMuted}`} />
            </button>
          );
        })}
      </div>
    </BottomSheet>
  );
};

export default MeQuickPanel;
